export default __webpack_public_path__ + "static/media/Pope_photo_large.f5d3592a.svg";